import { render, staticRenderFns } from "./TeacherSection3.vue?vue&type=template&id=3afc9a70&"
import script from "./TeacherSection3.vue?vue&type=script&lang=js&"
export * from "./TeacherSection3.vue?vue&type=script&lang=js&"
import style0 from "./TeacherSection3.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
